<template>
    <div class="pt-15 animated fadeIn masterGLaccount staticPageInner equipmentList bgV2">
        <b-row no-gutters>
            <b-col md="12" class="heig-frame-child">
                <gofix-tab
                    class="mt-3 contractPropertyTab"
                    activeKey="resident-site"
                    variableWidth
                    :data="tabs">
                    <template slot="gofixTab:resident-site">
                        <gofix-card class="mb-0 heig-frame-child" fullContent>
                            <gofix-default-table :settings="tableConfig"
                                :table-items="tableItems"
                                @load-items="getTableData"
                                @new-item="openCreateModal"
                                @delete-items="deleteItems"
                                @row-click="openCreateModal"
                                ref="gofixTable">
                                <template slot="gofix_table:property_id" slot-scope="row">
                                    {{localHref + "/#/residents-feedback?property_id=" + row.item.property_id}}
                                </template>
                            </gofix-default-table>
                        </gofix-card>
                    </template>
                </gofix-tab>
            </b-col>
        </b-row>
        <b-modal :no-close-on-backdrop="true"
            @hidden="closeCreateModal"
            id="modal-Create"
            :title="modals.create.title" hide-footer :centered="true"
            v-model="modals.create.open">
            <b-form class="pb-20">
                <b-row>
                    <b-col md="12">
                        <gofix-form-dropdown
                            label="Client Contract"
                            vLabel="contract_name"
                            :required="true"
                            :reduce="contract => contract.id"
                            v-model="modals.create.data.client_contract_id"
                            :options="modals.create.contract" />
                    </b-col>
                    <b-col md="12">
                        <gofix-form-properties
                            label="Property"
                            :contract-id="modals.create.data.client_contract_id"
                            v-model="modals.create.data.property"
                            valueFormat="object"
                            required />
                    </b-col>
                    <b-col md="12">
                        <gofix-form-input label="Site name" v-model="modals.create.data.site_name" />
                    </b-col>
                </b-row>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="APPLY" @click="saveData" :loading="modals.create.loading" noBorder></gofix-button>
            </b-button-group>
            <div class="preview" v-if="modals.create.data.property">
                <hr/>
                <gofix-text-field class="mb-3" label="URL" inputStyle>
                    {{modals.create.data.property ? localHref + "/#/residents-feedback?property_id=" + modals.create.data.property.id : ""}}
                </gofix-text-field>
                <gofix-text-field label="QR Code" inputStyle>
                    <div class="text-center">
                        <qrcode-vue :value="modals.create.data.property ? localHref + '/#/residents-feedback?property_id=' + modals.create.data.property.id : ''" :size="130" level="L"></qrcode-vue>
                        <gofix-button label="Download Hi-res QR Image" @click="downloadQRCode" outline></gofix-button>
                    </div>
                </gofix-text-field>
            </div>
        </b-modal>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import { filters } from '@/_filterVar.js';
    import QrcodeVue from 'qrcode.vue'

    export default {
        name: 'resident-site',
        components: {
            QrcodeVue,
        },
        data() {
            let filter = JSON.parse(JSON.stringify(filters['resident_site']));
            return {
                tabs: [
                    {
                        key: "resident-site",
                        title: "Resident Site",
                        active: true,
                        link: `/v2/resident-site`
                    },
                ],
                tableConfig:{
                    name: 'resident-sites-listing',
                    controls:{
                        tableImport: false,
                        tableExport: false,
                        create: this.$checkRole(this.$accessModule.resident_site, 'create'),
                        delete: this.$checkRole(this.$accessModule.resident_site, 'delete'),
                    },
                    filter: filter,
                    page: 1,
                    limit: 100,
                    total: 0,
                    useDatabaseView: true,
                    sortColumn: "contract_name",
                    sortDirection: "asc",
                },
                tableItems: [],
                modals:{
                    create:{
                        open:false,
                        loading: false,
                        title: "Add Resident Site",
                        data:{
                            id: null,
                            property: null,
                            property_id: null,
                            client_contract_id: null,
                            site_name: null
                        },
                        contract:[],
                        properties: [],
                    }
                },
                localHref : window.location.origin
            }
        },
        computed: {
            ...mapGetters({
                ClientContractID: 'ContractController/ClientContractID'
            })
        },
        watch : {
            "modals.create.data.client_contract_id": function(val,old){
                if(old){
                    this.modals.create.data.property = null;
                    this.modals.create.data.property_id = null;
                }
            },
        },
        created() {
            this.loadContract();
        },
        methods: {
            async getTableData(callback) {
                const { tableRequest , resolve,reject } = await callback();
                await this.$store.dispatch("TenantSiteController/getItems", tableRequest)
                    .then(response => {
                        this.tableItems = response.items;
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        this.$alertNotification("Can not load the items", "danger");
                        reject();
                    })
            },
            async deleteItems(callback){
                const { ids,filter, resolve,reject } = await callback();
                this.$store.dispatch("TenantSiteController/deleteItems", ids)
                    .then(response => {
                        resolve(this.$notificationV2('deleting', 'resident_site'));
                    })
                    .catch(err =>{
                        reject(err);
                    });
            },
            loadContract(){
                this.$store.dispatch('ContractController/getListClientContractsSearch', [1, null, -1])
                    .then(response => {
                        this.modals.create.contract = response.data;
                    })
                    .catch(error => {
                        console.log(error);
                        this.modals.create.contract = [];
                    });
            },
            openCreateModal(item){
                if(!item){
                    this.modals.create.title = "Add Resident Site";
                    this.modals.create.data = {
                        id: null,
                        property: null,
                        property_id: null,
                        client_contract_id: this.ClientContractID && this.ClientContractID.id ? this.ClientContractID.id : null,
                        site_name: null,
                    }
                }else{

                    if ( this.$checkRole(this.$accessModule.resident_site, 'update') == false ) {
                        return;
                    }

                    this.modals.create.title = "Edit Resident Site";
                    this.modals.create.data = {
                        id: item.id,
                        property: {
                            name: item.property_name,
                            id: item.property_id,
                        },
                        property_id: item.property_id,
                        client_contract_id: item.client_contract_id,
                        site_name: item.site_name,
                    };
                }
                this.modals.create.open = true;
            },
            closeCreateModal(){
                this.modals.create.title = "Add Resident Site";
                this.modals.create.data = {
                    id: null,
                    property: null,
                    property_id: null,
                    client_contract_id: null,
                    site_name: null,
                }
            },
            saveData() {
                if(!this.modals.create.data.site_name) return this.$alertNotification("Please enter the site name", "danger");
                if(!this.modals.create.data.client_contract_id) return this.$alertNotification("Please select a contract", "danger");
                if(!this.modals.create.data.property) return this.$alertNotification("Please select a property", "danger");

                if(this.modals.create.data.property && this.modals.create.data.property.id && this.modals.create.data.property.isBatch){
                    return this.$alertNotification("You are required to select the last level of Property", "danger");
                }

                if(this.modals.create.loading) return;
                this.modals.create.loading = true;
                this.modals.create.data.property_id = this.modals.create.data.property ? this.modals.create.data.property.id : null;

                let params = JSON.parse(JSON.stringify(this.modals.create.data));
                params.module_type = "Resident";

                let action = 'createItem';
                let keyMessage= 'adding'
                if(this.modals.create.data.id){
                    action = 'updateItem';
                    keyMessage = 'editing'
                }
                this.$store.dispatch(`TenantSiteController/${action}`, params)
                    .then(result => {
                        this.modals.create.loading = false;
                        this.modals.create.open = false;
                        this.$alertNotification(this.$notificationV2(keyMessage, 'resident_site'));
                        this.$store.dispatch("AuthController/getRoles");
                        this.$refs.gofixTable.reloadTableKeepFilter();
                    })
                    .catch(error => {
                        this.modals.create.loading = false;
                        return this.$alertNotification(error.response.data.error.message.message, "danger");
                    })
            },
            downloadQRCode() {
                this.$store.dispatch(`TenantSiteController/dowloadQRCode`, this.modals.create.data.id)
                    .then(response => {
                        const link = document.createElement('a');
                        link.href = response;
                        link.setAttribute('download', `${this.modals.create.data.site_name}.png`);
                        document.body.appendChild(link);
                        link.click();
                    })
                    .catch(error => {
                        console.log(error);
                    })
            }
        }
    }
</script>
